module.exports = __webpack_public_path__ + "img/loading.7.7cecf250.gif";